import styled from 'styled-components';
import { colors } from '../../utils/utils';

export const ModalButton = styled.button<{
    $color: string;
    $disabledColor?: string;
    $isOutline?: boolean;
}>`
    border-radius: 18px;
    border: 1px solid ${props => props.$color};
    display: block;
    width: 100%;

    text-transform: uppercase;
    padding: 8px 16px;
    letter-spacing: 1px;
    font-weight: normal;

    background-color: ${props => (props.$isOutline ? colors.white.basic : props.$color)};
    color: ${props => (props.$isOutline ? props.$color : colors.white.basic)};

    cursor: pointer;

    outline: none;

    & > * {
        vertical-align: middle;
    }

    & > span {
        margin-left: 6px;
    }

    &:hover {
        box-shadow: 0 2px 4px 0 ${colors.gray.mischka};
    }

    &:disabled {
        border: 1px solid ${props => props.$disabledColor || colors.gray.light};
        background-color: ${props => props.$disabledColor || colors.gray.light};
    }
`;

export default ModalButton;
